<script setup>
import useOutStorageTable from "./hooks/useOutStorageTable";
import Adjust from "./adjust.vue";
import { PROCESS_STATUS, TAG_TYPE } from "@/constants";
import useStashList from "../../hooks/useStashList";
import { onMounted, ref } from "vue";
import { DICT_KEY } from "@/constants/dict";
import { queryDictList } from "@/api/dict";

const { stashList } = useStashList();

const outStorageTypeList = ref([]);
const {
  searchRef,
  searchData,
  columns,
  outBoundTotal,
  tableData,
  tableLoading,
  pages,
  handleSizeChange,
  handleCurrentChange,
  editRef,
  datePicker,
  tableRef,
  handleReset,
  getList,
  handleAdjust,
  handleExport,
  datePickerChange,
  handleSelectionChange,
  handleBatchDelete,
} = useOutStorageTable();

onMounted(() => {
  getList();
  queryDictList(DICT_KEY["boundTypeOut"]).then((res) => {
    outStorageTypeList.value = res.data || [];
  });
});
</script>

<template>
  <zh-table-page v-bind="{ title: '出库管理' }">
    <template #header-btn
      ><el-button type="primary" icon="Plus" @click="handleAdjust(null, true)"
        >新增</el-button
      ></template
    >
    <template #search>
      <el-form :model="searchData" ref="searchRef" label-width="90px">
        <el-row :gutter="10">
          <el-col :span="5">
            <el-form-item label="出库单号：" prop="number">
              <el-input v-model="searchData.number" placeholder="请输入" />
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="出库类型：" prop="type">
              <el-select
                v-model="searchData.type"
                placeholder="请选择"
                style="width: 90%"
              >
                <el-option
                  v-for="item in outStorageTypeList"
                  :key="item.id"
                  :label="item.dictLabel"
                  :value="item.dictValue"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="出库仓库：" prop="warehouseId">
              <el-select
                v-model="searchData.warehouseId"
                placeholder="请选择"
                style="width: 90%"
              >
                <el-option
                  v-for="item in stashList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="物料名称：" prop="materialNameText">
              <el-input
                v-model="searchData.materialNameText"
                placeholder="请输入"
              />
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="工程名称：" prop="thirdResourceName">
              <el-input
                v-model="searchData.thirdResourceName"
                placeholder="请输入"
              />
            </el-form-item>
          </el-col>
          <el-col :xl="6" :sm="8">
            <el-form-item label="出库时间：">
              <el-date-picker
                v-model="datePicker"
                type="datetimerange"
                placeholder="请选择"
                style="width: 100%"
                @change="datePickerChange"
                format="YYYY-MM-DD HH:mm:ss"
                value-format="YYYY-MM-DD HH:mm:ss"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
              />
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item> </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </template>
    <template #table>
      <!-- <el-button icon="Delete" @click="handleBatchDelete(null, true)"
        >批量删除</el-button
      > -->
      <el-button icon="Download" @click="handleExport()">导出</el-button>
      <el-button type="primary" icon="Search" @click="getList()"
        >查询</el-button
      >
      <el-button icon="Refresh" @click="handleReset()">重置</el-button>
      <div class="total">
        <span>出库总单数: {{ outBoundTotal.count || 0 }}</span>
        <span class="price"
          >出库物料总数: {{ outBoundTotal.changeQuantity || 0 }}</span
        >
      </div>
      <el-table
        ref="tableRef"
        :header-cell-style="{ 'text-align': 'center' }"
        :cell-style="{
          'text-align': 'center',
        }"
        style="width: 100%; margin-top: 10px"
        max-height="500"
        v-loading="tableLoading"
        :data="tableData"
        @selection-change="handleSelectionChange"
      >
        <!-- <el-table-column type="selection" width="55" fixed /> -->
        <template v-for="item in columns" :key="item.prop">
          <el-table-column
            :label="item.label"
            :prop="item.prop"
            :min-width="120"
            show-overflow-tooltip
          >
            <template #default="{ row }">
              <span v-if="['boundType'].includes(item.prop)">{{
                row[item.prop]?.desc
              }}</span>
              <el-tag
                v-else-if="item.prop == 'processStatus'"
                :type="TAG_TYPE[row[item.prop]?.value]"
              >
                {{ row[item.prop]?.desc }}
              </el-tag>
              <span v-else>{{ row[item.prop] || "-" }}</span>
            </template>
          </el-table-column>
        </template>
        <el-table-column label="操作" width="150" fixed="right">
          <template #default="{ row }">
            <el-button type="primary" link @click="handleAdjust(row, false)"
              >查看</el-button
            >
            <!-- <el-button type="danger" link @click="handleBatchDelete(row.id, false)">删除</el-button> -->
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-if="pages.total > 0"
        background
        style="margin-top: 10px"
        :current-page="pages.page"
        :page-size="pages.size"
        :page-sizes="[10, 20, 30, 50]"
        :total="pages.total"
        layout="->, total, prev, pager, next, sizes, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </template>
  </zh-table-page>
  <Adjust ref="editRef" @after-save="getList" />
</template>

<style lang="less" scoped>
.total {
  display: inline-block;
  color: #409eff;
  margin-left: 20px;
  font-size: 12px;
  .price {
    margin-left: 20px;
  }
}
</style>
